<template>
  <ODialog ref="dialog" :maxWidth="800" hideWhenLoading>
    <v-card v-if="row != null">
      <v-tabs v-model="currentTab" background-color="grey lighten-2">
        <v-tab href="#overview">Geral</v-tab>
        <v-tab href="#json">JSON</v-tab>
        <v-tab href="#contents">Conteúdo</v-tab>
        <v-tab href="#preview">Preview</v-tab>
        <v-tab href="#extrainfo">ExtraInfo</v-tab>

        <v-tab-item value="overview">
          <v-card-text class="pa-3">
            <v-row wrap class="ma-0">
              <v-col cols="2" class="cap-cont pa-3">
                <label>ID</label>
                <p>{{ row.id }}</p>
              </v-col>
              <v-col cols="4" class="cap-cont pa-3">
                <label>Tipo</label>
                <p>{{ row.information }}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Label</label>
                <p>{{ row.label }}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Criado em</label>
                <p>{{ row.createdAt | moment }}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Entregue em</label>
                <p>{{ row.deliveredAt | moment }}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Apagado em</label>
                <p>{{ row.deletedAt | moment }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="json">
          <v-card-text class="pa-4 maxh-5">
            <v-btn small @click="copyToClipboard" class="mb-4">
              <v-icon small>mdi-clipboard</v-icon>
              Copiar para o Clipboard
            </v-btn>
            <pre>{{ row | prettyJson | ifBlank('(vazio)') }}</pre>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="contents">
          <v-card-text class="pa-4" v-if="hasContentsViewer">
            <v-text-field
              class="pa-0"
              v-model="txtKeywords"
              label="Filtro por palavra-chave"
              clearable
              single-line
              hide-details
            />
          </v-card-text>
          <v-card-text class="pa-0 maxh-5">
            <MailboxDrivers
              v-if="row.information == 'driverSet'"
              :originJson="row.originJson"
              :keywords="txtKeywords"
            />
            <MailboxEis
              v-else-if="row.information == 'embeddedRulesSet'"
              :originJson="row.originJson"
              :keywords="txtKeywords"
            />
            <MailboxPolygons
              v-else-if="row.information == 'polygonSet'"
              :originJson="row.originJson"
              :keywords="txtKeywords"
            />
            <template v-else-if="row.information == 'configsV2'">
              <SimpleConfigsViewer
                v-if="row.originJson.allConfigs != null"
                :allConfigs="row.originJson.allConfigs"
              />
              <OAlert error v-else>
                Mailbox de configs não possui valores!
              </OAlert>
            </template>
            <template v-else-if="row.information == 'wifiConfig'">
              <WifiViewer
                v-if="row.originJson.networks != null"
                :networks="row.originJson.networks"
              />
              <OAlert error v-else>
                Mailbox de wifi não possui redes!
              </OAlert>
            </template>
            <div class="pa-4" v-else>
              Não há um visualizador de conteúdo para este tipo de mailbox.
            </div>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="preview">
          <v-card-text class="pa-4 maxh-5">
            <pre>{{ preview | ifBlank('(sem preview)') }}</pre>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="extrainfo">
          <v-card-text class="pa-4">
            <pre>{{
              row.extraInfo | prettyJson | ifBlank('(sem extraInfo)')
            }}</pre>
          </v-card-text>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </ODialog>
</template>

<script>
import { MailboxItem } from '@/models'
import MailboxDrivers from '@/components/MailboxDrivers.vue'
import MailboxPolygons from '@/components/MailboxPolygons.vue'
import MailboxEis from '@/components/MailboxEis.vue'
import SimpleConfigsViewer from '../../../vehicle/configs2/SimpleConfigsViewer.vue'
import WifiViewer from '../../../vehicle/wifi/WifiViewer.vue'

import brush from 'brush'

export default {
  components: {
    MailboxDrivers,
    MailboxPolygons,
    MailboxEis,
    SimpleConfigsViewer,
    WifiViewer
  },
  data() {
    return {
      isLoading: true,
      currentTab: '1',
      row: null,
      txtKeywords: null
    }
  },
  computed: {
    hasContentsViewer() {
      let info = this.row && this.row.information
      return (
        info == 'driverSet' ||
        info == 'polygonSet' ||
        info == 'embeddedRulesSet'
      )
    },
    preview() {
      // para mailbox configsV2, o originJson já contém os bytes
      // no formato hex com comentários
      if (this.row.originJson && this.row.originJson.bytes) {
        let a = this.row.originJson.address.toString(16).padStart(4, '0')
        let h = this.row.originJson.bytes
        let l = brush.hexToBytes(h).length
        return `STORE 0x${a} (${l} bytes)\n\n${h}`
      } else {
        return this.row.preview
      }
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.currentTab = '1'
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      this.row = await MailboxItem.findById(this.id)
    },
    copyToClipboard() {
      let obj = this.row.originJson
      navigator.clipboard.writeText(JSON.stringify(obj, null, ' '))
      this.$snack('Copied to clipboard')
    }
  }
}
</script>

<style></style>
